<template>
    <div class="pb-2 select-none">
        <div class="py-2">
            <SwitchButton
                v-model="templateVersionState.approved"
                :state="templateVersionState.approved ? 'success' : 'danger'"
                :label="t('isPdfUaStrict')"
                :label-on="t('isPdfUaStrictOn')"
                :label-off="t('isPdfUaStrictOff')"
                :is-disabled="!config.roles.validators.includes(loggedUser.role)"
            />
        </div>
    </div>
</template>

<script setup>
import { reactive, watch } from 'vue';
import { getLoggedUser } from '../composables/useLogin';
import SwitchButton from '../ui/SwitchButton.vue';

defineExpose({
    name: 'AccessiblePDF',
});

const props = defineProps({
    templateVersionModel: {
        type: Object,
        required: true,
    },
});

const templateVersionModel = props.templateVersionModel;
const loggedUser = getLoggedUser();
const templateVersionState = reactive({
    approved: templateVersionModel.isPdfUaStrict,
});

watch(templateVersionState, () => {
    templateVersionModel.isPdfUaStrict = templateVersionState.approved;
});
</script>
